import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaotransferencia(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaotransferencia/FIND_OPERACAOTRANSFERENCIA':
      case '@operacaotransferencia/UPDATE_OPERACAOTRANSFERENCIA':
      case '@operacaotransferencia/DELETE_OPERACAOTRANSFERENCIA':
      case '@operacaotransferencia/STORE_OPERACAOTRANSFERENCIA':
      case '@operacaotransferencia/OPERACAOTRANSFERENCIAS_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@operacaotransferencia/SUCCESS_REMOVE':
      case '@operacaotransferencia/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaotransferencia/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaotransferencias;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaotransferencia/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaotransferencia;
        break;
      }

      case '@operacaotransferencia/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
